export default __webpack_public_path__ + "static/media/whitepaper-icon.dbc8301e.svg";